import { render, staticRenderFns } from "./manage-profile.vue?vue&type=template&id=40a18c70&scoped=true"
import script from "./manage-profile.vue?vue&type=script&lang=ts"
export * from "./manage-profile.vue?vue&type=script&lang=ts"
import style0 from "./manage-profile.vue?vue&type=style&index=0&id=40a18c70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a18c70",
  null
  
)

export default component.exports